<div class="tour-items-bar-container" *ngIf="itemCount">
  <div class="item-category-container">
    <mat-icon [svgIcon]="iconName.baggage"></mat-icon>
    <br>
    {{ itemCount.baggage }}
  </div>
  <div class="item-category-container">
    <mat-icon [svgIcon]="iconName.ski"></mat-icon>
    <br>
    {{ itemCount.ski }}
  </div>
  <div class="item-category-container">
    <mat-icon [svgIcon]="iconName.bike"></mat-icon>
    <br>
    {{ itemCount.bike }}
  </div>
  <div class="item-category-container">
    <mat-icon [svgIcon]="iconName.ebike"></mat-icon>
    <br>
    {{ itemCount.ebike }}
  </div>
  <div class="item-category-container">
    <mat-icon [svgIcon]="iconName.specialbike"></mat-icon>
    <br>
    {{ itemCount.specialbike }}
  </div>
  <div class="item-category-container">
    <mat-icon [svgIcon]="iconName.cm"></mat-icon>
    <br>
    {{ itemCount.cm }}
  </div>
</div>
